import React from 'react'
import SimpleChart from '../statistics/SimpleChart'
import MainTitle from '../common/MainTitle'
import CustomHr from '../common/CustomHr'
import { translate } from 'utlis/translations/i18n'

const RateImageChart = ({ preferencesData, maximum, metadata }) => {
    return (
        <div>
            <MainTitle text={translate('preferencesHistogram')} />
            <SimpleChart
                key={0}
                data={preferencesData}
                maximum={maximum}
                value="Evaluation"
                domain={[0, 1]}
                YName={translate('averageScore')}
                XName='Image'
                attributes={metadata.attributes}
            />
            <CustomHr />
        </div>
    )
}

export default RateImageChart
